import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button, Drawer, FormControl, FormControlLabel, Switch, TextField, Select, MenuItem, InputLabel, ListItemText, Checkbox} from "@mui/material";
import * as React from "react";

export default function StaffVetsAddVet(props) {

    const ShowForm = (props) => {

        const [id, setId] = useState(props.currentData.id || 0);
        const [frmName, setFrmName] = useState(props.currentData.business_name || '');
        const [frmMerco, setFrmMerco] = useState(props.currentData.merco_id || '');
        const [frmEmail, setFrmEmail] = useState(props.currentData.email || '');
        const [frmEmailAccounts, setFrmEmailAccounts] = useState(props.currentData.email_accounts || '');
        const [frmPhone, setFrmPhone] = useState(props.currentData.phone || '');
        const [frmWeb, setFrmWeb] = useState(props.currentData.supplier_website || '');
        const [frmHours, setFrmHours] = useState(props.currentData.supplier_hours || '');
        const [frmTerms, setFrmTerms] = useState(props.currentData.supplier_terms || '');
        const [frmTermsCommunity, setFrmTermsCommunity] = useState(props.currentData.supplier_terms_community || '');
        const [frmCapacityInternal, setFrmCapacityInternal] = useState(props.currentData.capacity_internal || '');
        const [allVets, setAllVets] = useState([]);
        const [selectedVets, setSelectedVets] = useState(() => {
            const v = props.currentData.associated_vets;
            if (!v) return [];
            if (Array.isArray(v)) return v;
            // if comma-separated string, split
            if (typeof v === 'string') {
                return v.split(',').map(x => x.trim()).filter(x => x !== '').map(x => (isNaN(x) ? x : Number(x)));
            }
            // single number/id
            return [v];
        });
        const [optoutPublic, setOptoutPublic] = useState(false);
        const [optoutCommunity, setOptoutCommunity] = useState(false);
        const [internal, setInternal] = useState(false);
        const [pw, setPw] = useState('');
        const [pw1, setPw1] = useState('');

        useEffect(() => {
            setId(props.currentData.id || 0);
            setFrmName(props.currentData.business_name || '');
            setFrmName(props.currentData.business_name || '');
            setFrmMerco(props.currentData.merco_id || '');
            setFrmEmail(props.currentData.email || '');
            setFrmEmailAccounts(props.currentData.email_accounts || '');
            setFrmPhone(props.currentData.phone || '');
            setFrmWeb(props.currentData.supplier_website || '');
            setFrmHours(props.currentData.supplier_hours || '');
            setFrmTerms(props.currentData.supplier_terms || '');
            setFrmTermsCommunity(props.currentData.supplier_terms_community || '');
            setOptoutPublic(props.currentData.optout_public === 1 || false);
            setOptoutCommunity(props.currentData.optout_community === 1 || false);
            setInternal(props.currentData.internal === 1 || false);
            // load list of all vets for multi-select (used to associate vets)
            FunctionsData.fetchDataGetNoLoading(FunctionsData.getApiUrl('/api/vet/'), (data) => {
                const list = data || [];
                const currentId = props.currentData?.id || null;
                setAllVets(list.filter(v => v.id !== currentId));
            });
        }, [])

        function isEmail(val) {
            let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regEmail.test(val);
        }

        async function submit() {

            let body = {};
            if (pw !== '' || props.mode === 'new') {
                body = {
                    business_name: frmName,
                    merco_id: frmMerco,
                    email: frmEmail,
                    email_accounts: frmEmailAccounts,
                    phone: frmPhone,
                    supplier_hours: frmHours,
                    supplier_website: frmWeb,
                    supplier_terms: frmTerms,
                    supplier_terms_community: frmTermsCommunity,
                    password: pw,
                    capacity_internal: frmCapacityInternal,
                    optout_public:(optoutPublic) ? 1 : 0,
                    optout_community:(optoutCommunity) ? 1 : 0,
                    internal:(internal) ? 1 : 0,
                    associated_vets: selectedVets
                };
            } else {
                body = {
                    business_name: frmName,
                    merco_id: frmMerco,
                    email: frmEmail,
                    email_accounts: frmEmailAccounts,
                    phone: frmPhone,
                    supplier_hours: frmHours,
                    supplier_website: frmWeb,
                    supplier_terms: frmTerms,
                    supplier_terms_community: frmTermsCommunity,
                    capacity_internal: frmCapacityInternal,
                    optout_public:(optoutPublic) ? 1 : 0,
                    optout_community:(optoutCommunity) ? 1 : 0,
                    internal:(internal) ? 1 : 0,
                    associated_vets: selectedVets
                };
            }

            const tkn = await FunctionsData.getCSRFToken();
            let requestOptionsVoucher = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': sessionStorage.sTkn,
                    'X-CSRF-Token': tkn.csrf
                },
                body: JSON.stringify(body)
            };


            if (props.mode === "new") {
                await fetch(FunctionsData.getApiUrl("/api/vet/"), requestOptionsVoucher)
                    .then(response => response.json())
                    .then((res) => {
                        props.setLoading(true);
                        props.setIsOpen(false);
                    })
            } else {
                await fetch(FunctionsData.getApiUrl("/api/vet/") + id, requestOptionsVoucher)
                    .then(response => response.json())
                    .then((res) => {
                        props.setLoading(true);
                        props.setIsOpen(false);
                    })
            }

        }

        return (
            <Drawer
                anchor={"right"}
                open={props.isOpen}
                onClose={() => props.setIsOpen(false)}
            >
                <div style={{width: 500, padding: 20}}>
                    <h1 style={{marginBottom: 30}}>{
                        (props.mode === 'new') ?
                            "Add a new vet" : "Modify an existing vet"
                    }</h1>
                    <hr style={{margin:'20px 0'}} />
                    <div><FormControlLabel control={<Switch checked={!optoutPublic} onChange={() => setOptoutPublic(!optoutPublic)} />} label="Snip'nChip" /></div>
                    <div><FormControlLabel control={<Switch checked={!optoutCommunity} onChange={() => setOptoutCommunity(!optoutCommunity)} />} label="Community" /></div>
                    <hr style={{margin:'20px 0'}} />
                    <div><FormControlLabel control={<Switch checked={internal} onChange={() => setInternal(!internal)} />} label="Internal vet" /></div>
                    {/* Associate with existing vets (multi-select) */}
                    <FormControl fullWidth variant="outlined" sx={{marginBottom:2, marginTop:2, '& .MuiInputLabel-root': {fontSize:13}}}>
                        <InputLabel
                            id="assoc-vets-label"
                            htmlFor="assoc-vets-select"
                            sx={{
                                background: '#fff',
                                px: 0.75,
                                fontWeight: 400,
                                fontSize: 13,
                                color: 'rgba(0,0,0,0.6)',
                                transform: 'translate(14px, -8px)'
                            }}
                        >Associate vets</InputLabel>
                        <Select
                            id="assoc-vets-select"
                            labelId="assoc-vets-label"
                            label="Associate vets"
                            multiple
                            value={selectedVets}
                            onChange={(e) => setSelectedVets(e.target.value)}
                            renderValue={(selected) => allVets.filter(v => selected.includes(v.id)).map(v=>v.business_name).join(', ')}
                            sx={{
                                '& .MuiSelect-select': { padding: '12px 14px', minHeight: '44px' },
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.23)' },
                                '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2' },
                                '& .MuiInputLabel-root.Mui-focused': { color: '#1976d2' }
                            }}
                        >
                            {allVets.map(v => (
                                <MenuItem key={v.id} value={v.id}>
                                    <Checkbox checked={selectedVets.indexOf(v.id) > -1} />
                                    <ListItemText primary={v.business_name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <hr style={{margin:'20px 0'}} />
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={(frmName === '')}
                            label="Vet - Business name"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmName}
                            onChange={(e) => setFrmName(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{marginBottom: 3, marginTop: 2}}>
                        <TextField
                            error={(frmMerco === '')}
                            label="Merco ID"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmMerco}
                            onChange={(e) => setFrmMerco(e.target.value)}
                            focused
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            error={!isEmail(frmEmail) || frmEmail === ''}
                            label="Email"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmEmail}
                            onChange={(e) => setFrmEmail(e.target.value)}
                            focused
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            error={!isEmail(frmEmailAccounts) || frmEmailAccounts === ''}
                            label="Finance accounts email"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmEmailAccounts}
                            onChange={(e) => setFrmEmailAccounts(e.target.value)}
                            focused
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            error={(frmPhone === '')}
                            label="Phone"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmPhone}
                            onChange={(e) => setFrmPhone(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            error={(frmWeb === '')}
                            label="Website"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmWeb}
                            onChange={(e) => setFrmWeb(e.target.value)}
                            focused
                        />
                    </FormControl>

                    {/*<FormControl fullWidth sx={{marginBottom: 3}}>*/}
                    {/*    <TextField*/}
                    {/*        error={(frmHours === '')}*/}
                    {/*        label="Opening hours"*/}
                    {/*        type="text"*/}
                    {/*        aria-describedby="component-helper-text"*/}
                    {/*        value={frmHours}*/}
                    {/*        onChange={(e) => setFrmHours(e.target.value)}*/}
                    {/*        focused*/}
                    {/*    />*/}
                    {/*</FormControl>*/}

                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            error={(props.mode === 'new' && pw === '')}
                            label="Password (Leave empty if no change)"
                            type="password"
                            aria-describedby="component-helper-text"
                            value={pw}
                            onChange={(e) => setPw(e.target.value)}
                            focused
                        />
                        {(pw !== '') ? "The password will be reset." : ""}
                    </FormControl>

                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            error={(pw !== pw1)}
                            label="Repeat password"
                            type="password"
                            aria-describedby="component-helper-text"
                            value={pw1}
                            onChange={(e) => setPw1(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            label="Capacity (Internal)"
                            type="number"
                            aria-describedby="component-helper-text"
                            value={frmCapacityInternal}
                            onChange={(e) => setFrmCapacityInternal(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            multiline
                            rows={5}
                            label="Terms & conditions (Public)"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmTerms}
                            onChange={(e) => setFrmTerms(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{marginBottom: 3}}>
                        <TextField
                            multiline
                            rows={5}
                            label="Terms & conditions (Community)"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmTermsCommunity}
                            onChange={(e) => setFrmTermsCommunity(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <Button variant={"contained"}
                            disabled={(
                                frmName === '' ||
                                frmMerco === '' ||
                                frmEmail === '' ||
                                frmEmailAccounts === '' ||
                                frmPhone === '' ||
                                frmWeb === '' ||
                                pw !== pw1 || (props.mode === 'new' && pw === '') ||
                                !isEmail(frmEmail) || !isEmail(frmEmailAccounts)
                            )}
                            onClick={submit}>Save vet</Button>
                    <Button variant={""} sx={{marginLeft: 1}} onClick={() => props.setIsOpen(false)}>Cancel</Button>
                </div>
            </Drawer>
        );
    }

    return (
        <ShowForm isOpen={props.isOpen}
                  setIsOpen={props.setIsOpen}
                  setLoading={props.setLoading}
                  {...props}
        />
    )

}
